<script setup lang="ts">
import type { components } from "assets/api/openapi"
import ForeignTrainingGroupTable from "@/components/workflows/pug/work-steps/03-ausbildungsvergleich/foreign-tranings/foreign-training-group-table.vue"

interface Props {
  template: components["schemas"]["TrainingTemplate"]
  configurationType: "HOUR_COMPARISON" | "HOUR_DEFICIT"
}

const props = defineProps<Props>()

const trainingGroups = computed(() => {
  if (!props.template.trainingGroups) return []

  return Object.entries(props.template.trainingGroups).map(
    ([groupName, assessments]) => ({
      groupName,
      assessments: assessments || [],
    })
  )
})
</script>

<template>
  <div class="space-y-6">
    <ForeignTrainingGroupTable
      v-for="(group, index) in trainingGroups"
      :key="group.groupName"
      :group-name="group.groupName"
      :assessments="group.assessments"
      :configuration-type="configurationType"
      :is-last="index === trainingGroups.length - 1"
    />

    <IffContentSection
      v-if="trainingGroups.length === 0"
      headline="Keine Trainingsgruppen"
      :is-last-child="false"
    >
      <div class="text-center py-8 text-gray-500">
        Diese Vorlage enthält keine Trainingsgruppen.
      </div>
    </IffContentSection>
  </div>
</template>
